import { Grid } from "@mui/material";
import React from "react";
import { ProfileInsuranceInsurancePadding } from "../Insurance/InsuranceForm.styles";
import { PatientInsuranceInfo } from "./helpers";
import InsuranceFileUploader, {
  FileUploadInfo,
} from "../Insurance/InsuranceFileUploader";
import { InsuranceUploadType } from "../Insurance/types";

const ProfileInsuranceUpload: React.FC<{
  patientInsuranceInfo: PatientInsuranceInfo;
  setPatientInsuranceInfo: React.Dispatch<
    React.SetStateAction<PatientInsuranceInfo>
  >;
  insuranceType: InsuranceUploadType;
}> = ({ patientInsuranceInfo, setPatientInsuranceInfo, insuranceType }) => (
  <ProfileInsuranceInsurancePadding
    $show={patientInsuranceInfo.billToInsuranceType === "Upload"}
  >
    <Grid item xs={12}>
      <InsuranceFileUploader
        setValue={(files: FileUploadInfo) => {
          setPatientInsuranceInfo({
            ...patientInsuranceInfo,
            insuranceFileUrls: files,
          });
        }}
        insuranceType={insuranceType}
      />
    </Grid>
  </ProfileInsuranceInsurancePadding>
);
export default ProfileInsuranceUpload;
